<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <!-- modal title -->
        <h5 *iCms="'title' of content"
            class="h3"></h5>

        <!-- modal title -->
        <div *iCms="'subtitle' of content"
             class="p1 m-t-9"></div>
    </ng-container>
    <ng-container ngProjectAs="[modalBody]">
        <!-- stores list XLM-->

        <div class="p-a-5"
             *ifSize="'!S'">
            @for (store of stores; track $index; let index = $index) {
            <a [attr.href]="getStoreUrl(store)"
               (click)="goTo(store.siteId)"
               class="flex flex-middle"
               [class.m-t-9]="index">
                <!-- store icon -->
                <img [image]="store.icon"
                     class="store-icon"
                     *iCms="'icon' of store; skipEmpty: true">
                <!-- store title -->
                <div *iCms="'title' of store"
                     class="p1 m-l-2"></div>
            </a>
            }
        </div>

        <!-- stores list S-->
        <div class="p-a-5"
             *ifSize="'S'">
            <select class="select w-12 p1"
                    required
                    [(ngModel)]="selectedStore"
                    (change)="onStoreChange()">
                <option disabled
                        value="undefined">{{'Select Country' | translate}}</option>
                @for (store of stores; track $index) {
                <option [attr.href]="getStoreUrl(store)"
                        [value]="store.siteId">
                    <!-- store title -->
                    <div *iCms="'title' of store"
                         class="p1 m-l-2"
                         text></div>
                </option>
                }
            </select>
        </div>
    </ng-container>

    <ng-container ngProjectAs="[modalFooter]">
        <div class="p-a-5">
            @if (content.closeBtnCopy) {
            <button class="w-12 button"
                    (click)="close()">
                <span *iCms="'closeBtnCopy' of content"></span>
            </button>
            }
        </div>
    </ng-container>
</modal-layout-right>